import React, { useContext, Suspense } from "react";

import { Text } from "@aidron/aidron-ds";
import { TenantContext } from "../../../templates/context/TenantContext";

import PropTypes from 'prop-types';
import { textFormatter } from "../../../utils/formatter/formatter";

export function ProductHierarchyHeading({ ctx, uiState }) {

  const { productId, products } = ctx || {};
  const { delimiter, page } = uiState || {};

  const { hierarchy } = useContext(TenantContext);

  const product = (products ?? []).find(product => product.productId === productId);
  const isDataReady = hierarchy?.labels && product;

  return (
    <div className="mb-2">
      <Suspense fallback={<ProductHierarchyHeading.LoadingStateManager />}>
        {isDataReady ? (
          <ProductHierarchyHeading.Heading ctx={{ hierarchy: hierarchy, product: product }} uiState={{ delimiter: delimiter, page: page }} />
        ) : (
          <ProductHierarchyHeading.LoadingStateManager />
        )}
      </Suspense>
    </div>
  );
}

ProductHierarchyHeading.Heading = ProductHierarchyContent;
ProductHierarchyHeading.LoadingStateManager = LoadingComponent;

function LoadingComponent() {
  return (
    <div
      style={{
        padding: '15px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="loading-spinner"></div>
      <span style={{ marginLeft: '10px' }}>
        Carregando dados do produto...
      </span>
    </div>
  );
};

function ProductHierarchyContent ({ ctx, uiState }) {

  const { hierarchy = {}, product = {} } = ctx || {};
  const { delimiter = "|", page = null } = uiState || {};

  const modalCardHeadingTitle = product[hierarchy?.levels[hierarchy?.levels?.length - 1]] 
    ? product[hierarchy.levels[hierarchy.levels.length - 1]] 
    : ""

  return (
    <>
      {
        page ? (
          <h5 style={{ fontSize: "1rem", fontWeight: 800 }} size="sm">{modalCardHeadingTitle}</h5>
        ) : (
          <h5 size="sm">{modalCardHeadingTitle}</h5>
        )
      }
      
      <Text size="xs">
        {hierarchy?.levels
          .slice(0, -1)
          .map((level, index, arr) => (
            <React.Fragment key={level}>
              <strong>{hierarchy?.labels[level]}</strong> {textFormatter(product[level])}
              {index !== arr.length - 1 ? ` ${delimiter} ` : ""}
            </React.Fragment>
          ))}
      </Text>
    </>
  );
};

ProductHierarchyHeading.propTypes = { ctx: PropTypes.shape() };
LoadingComponent.propTypes = { ctx: PropTypes.shape() };